import { render } from "./HomeView.vue?vue&type=template&id=3ecaf3db&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/fanglegefang/Desktop/Feiyi_sign_2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__